import loadable from '@loadable/component';


const ReviewsLazy = loadable(() => import('./Reviews'));

export default ReviewsLazy;
